import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { Input, Select, Textarea } from '../../../../components/base/index';
import { Link } from 'react-router-dom';

export default function AnalisaNilaiTable(props) {
  const { onFormChange, form } = props;
  return (
    <div className="daftar-ekskul__content">
                <div className="daftar-ekskul__header">
                  

                </div>
                <div className="daftar-ekskul__body">
                  <table className="daftar-ekskul__table">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Opsi</th>
                        <th>Jenis</th>
                        <th>Tanggal</th>
                        <th>Rata-rata</th>
                        <th>Daya Serap</th>
                        <th>Ketuntasan Belajar</th>
                        <th>Nilai Min</th>
                        <th>Nilai Max</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* {
                      map(journal.details, (list, idx) => (
                        <tr key={`journal_detail_${idx}`}>
                          <td>{idx + 1}</td>
                          <td>{list.code_of_account}</td>
                          <td>{list.parameter_code.title}</td>
                          <td>{list.description}</td>
                          <td className="nominal">{commaFormatted(list.amount)}</td>
                        </tr>
                      ))
                    } */}
                    <tr>
                        <td>1</td>
                        <td><Link to={'/dashboard/kesiswaan'}>PRINT</Link><br></br> 
                            <Link to={'/dashboard/kesiswaan'}>Edit</Link> 
                        </td>
                        <td>Ulangan/Quiz blablablaa</td>
                        <td>Tanggal <br>
                            </br><Link to={'/dashboard/kesiswaan'}>Del/</Link>
                            <Link to={'/dashboard/kesiswaan'}>Undel</Link> </td>
                        <td>-</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                       

                    </tr>
                   
                    </tbody>
                    {/* <tfoot>
                      <tr>
                        <td colSpan="1" className="nominal">Catatan Wali Kelas</td>
                        <td colSpan="8" className="nominal"></td>
                      </tr>
                    </tfoot> */}
                  </table>
                </div>
              </div>
  );
}
AnalisaNilaiTable.propTypes = {
  onFormChange: PropTypes.func,
  form: PropTypes.object.isRequired,
};
AnalisaNilaiTable.defaultProps = {
  onFormChange: noop,
};
